"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
// The comma in the type is to trick typescript because it things a single generic in a tsx file is jsx
exports.mergeRefs = (...refs) => (value) => refs.forEach((ref) => {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref != null) {
        // This is typed as readonly so we need to allow for override
        ref.current = value;
    }
});
exports.createForwardRef = (ReactComponent, displayName) => {
    const forwardRef = (props, ref) => {
        return react_1.default.createElement(ReactComponent, Object.assign({}, props, { forwardedRef: ref }));
    };
    forwardRef.displayName = displayName;
    return react_1.default.forwardRef(forwardRef);
};
__export(require("./attachProps"));
__export(require("./case"));
//# sourceMappingURL=index.js.map